const appVersion = '0.0.1';

export default appVersion;
